import React, { CSSProperties, FC } from 'react'
import { OutboundLink } from "gatsby-plugin-google-gtag"

type Props = {
    href: string,
    textStyle: CSSProperties
}

export const ExternalLinkText: FC<Props> = ( {
    href,
    textStyle
} ) =>
    <OutboundLink
        href={ href }
        style={ textStyle }
        target="_blank" >
        { href }
    </OutboundLink >
